import { FIELD_NAMES, FIELD_TYPES } from 'utils/constants';
import TextCoercion from './coercions/coerce.text';
import DegreeOfferingCoercion from './coercions/coerce.degree.offering';
import DropdownCoercion from './coercions/coerce.dropdown';
import MultiPicklistCoercion from './coercions/coerce.multipicklist';
import PicklistValueOptInCoercion from './coercions/coerce.picklist.value.opt.in';
import BooleanOptInCoercion from './coercions/coerce.boolean.opt.in';
import NonEditableFieldCoercion from './coercions/coerce.non.editable.field';
import RadioButtonCoercion from './coercions/coerce.radio.button';
import GDPRConsentCoercion from './coercions/coerce.gdpr.consent';
import PhoneCoercion from './coercions/coerce.phone';
import EmailCoercion from './coercions/coerce.email';

const COERCIONS = {
  [FIELD_TYPES.TEXT]: TextCoercion,
  [FIELD_TYPES.DEGREE_OFFERING]: DegreeOfferingCoercion,
  [FIELD_TYPES.DROPDOWN]: DropdownCoercion,
  [FIELD_TYPES.MULTIPICKLIST]: MultiPicklistCoercion,
  [FIELD_TYPES.OPTIN]: PicklistValueOptInCoercion,
  [FIELD_TYPES.PICKLIST_VALUE_OPT_IN]: PicklistValueOptInCoercion,
  [FIELD_TYPES.BOOLEAN_OPT_IN]: BooleanOptInCoercion,
  [FIELD_TYPES.RADIO_BUTTON]: RadioButtonCoercion,
  [FIELD_TYPES.STATE]: NonEditableFieldCoercion,
  [FIELD_TYPES.COUNTRY]: NonEditableFieldCoercion,
  [FIELD_TYPES.NATIONALITY]: NonEditableFieldCoercion,
  [FIELD_TYPES.NON_GDPR_CONSENT]: PicklistValueOptInCoercion,
  [FIELD_TYPES.GDPR_CONSENT]: GDPRConsentCoercion,
  [FIELD_TYPES.PHONE]: PhoneCoercion,
  [FIELD_TYPES.EMAIL]: EmailCoercion,
};

class Coercion {
  constructor(field) {
    this.field = field;

    if (this.__shouldBePhoneCoercion()) {
      this.__coercion = COERCIONS[FIELD_TYPES.PHONE];
      return;
    }

    if (this.__shouldBeEmailCoercion()) {
      this.__coercion = COERCIONS[FIELD_TYPES.EMAIL];
      return;
    }

    this.__coercion = COERCIONS[field.type];
  }

  fromGQL(obj, gdprSetting) {
    return this.__coercion.fromGQL(obj, gdprSetting);
  }

  overrideFromGQL(override) {
    return this.__coercion.overrideFromGQL(override);
  }

  toGQL(gdprSetting) {
    return this.__coercion.toGQL(this.field, gdprSetting);
  }

  overrideToGQL(override) {
    return this.__coercion.overrideToGQL(override);
  }

  exists() {
    return !!this.__coercion;
  }

  overrideExists() {
    return !!this.__coercion.overrideFromGQL;
  }

  __shouldBePhoneCoercion() {
    // This is to migrate existing text phone coercions to the new phone coercion
    return this.field.type === FIELD_TYPES.TEXT && this.field.name === FIELD_NAMES.PHONE;
  }

  __shouldBeEmailCoercion() {
    // This is to migrate existing text email coercions to the new email coercion
    return this.field.type === FIELD_TYPES.TEXT && this.field.name === FIELD_NAMES.EMAIL;
  }
}

export default Coercion;
